module.exports = __webpack_public_path__ + "img/noContent.b1d60ccf.png";